// mindzera-frontend/src/App.jsx
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';

import { useAuth } from './AuthContext.jsx'; // ✅ Auth hook

import Layout            from './Layout.jsx';
import Landing           from './Landing.jsx';
import How               from './How.jsx';
import Microskills       from './Microskills.jsx';
import About             from './About.jsx';
import Privacy           from './Privacy.jsx';
import YourMindzeraMap   from './YourMindzeraMap.jsx';
import SubscriptionsList from './SubscriptionsList.jsx';
import AssignSeats       from './AssignSeats.jsx';
import Builder           from './Builder.jsx';   // ✅ Protected page
import Login             from './Login.jsx';     // ✅ Login form

function RequireAuth({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Landing />} />
          <Route path="how"               element={<How />} />
          <Route path="microskills"       element={<Microskills />} />
          <Route path="about"             element={<About />} />
          <Route path="privacy"           element={<Privacy />} />
          <Route path="your-mindzera-map" element={<YourMindzeraMap />} />
          <Route path="subscriptions"            element={<SubscriptionsList />} />
          <Route path="subscriptions/:id/assign" element={<AssignSeats />} />
          <Route path="builder" element={
            <RequireAuth><Builder /></RequireAuth>
          } />
        </Route>

        <Route path="login" element={<Login />} />

        <Route
          path="*"
          element={
            <pre style={{ padding: 12, fontSize: 12 }}>
              404 – no route matched: {location.pathname}
            </pre>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
